import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import Dropzone from 'react-dropzone';
import * as Yup from 'yup';
import Select from 'react-select';
import IcomoonReact from 'icomoon-react';

import { CustomMultiValue, CustomOption, customSelectStyles } from './DocumentSelectComponents';
import {
  isUserInSelectedGroups,
  getVisibleUsers,
  handleUserChange,
  handleGroupChange,
  foldersRefiner,
  groupsRefiner,
  usersRefiner,
} from '../utils/documentAccessHelpers';
import Spinner from '../../../../shared/components/Spinner/Spinner';
import Text from '../../../../shared/components/Text/Text';
import SubText from '../../../../shared/components/SubText/SubText';
import Checkmark from '../../../../shared/components/Checkmark/Checkmark';
import Button from '../../../../shared/components/Button/Button';
import NoHoverButton from '../../../../shared/components/NoHoverButton';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import useDocuments from '../hooks/useDocuments';
import { showInfoToast } from '../../../../shared/utils/toastManager';

const ModalWrapper = styled('div')`
  display: flex;
  width: 100%;
  .modal-button {
    align-items: center;
    background: '#ff6600';
  }
`;

const FieldError = styled('div')`
  font-size: 14px;
  color: #ff6600;
  margin-top: 12px;
`;

const TitlePlusErrorWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AnotherWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const TextTypeWrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const NavigationWrapper = styled('div')`
  display: flex;
  justify-content:space-between;
  margin-top: -10px;
  width: 100%;
  margin-bottom: -20px;
  z-index: 1;
  .back-arrow-div {
    cursor: pointer;
  }
`;

const NavigationWrapperFolder = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  z-index: 1;
  .back-arrow-div {
    cursor: pointer;
  }
`;

const NavigationWrapperFile = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  z-index: 1;
  margin-bottom: -20px;
  .back-arrow-div {
    cursor: pointer;
  }
`;

const FormWrapper = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-top: 10px;
`;

const FileFormWrapper = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: 20px 0;
`;

const RightWrapper = styled('div')`
  width: 50%;
  display: flex;
  justify-content: left;
  align-items: center;

  .formik-form {
    width: 90%;
  }

`;

const TitleError = styled('div')`
  font-size: 14px;
  color: #ff6600;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const LeftWrapper = styled('div')`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
`;

const GlobeWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 40px;

  .globe-text {
    margin-top: 10px;
    font-size: 15px;
  }
`;

const URLWrapper = styled('div')`
  width: 90%;
  padding-bottom: 35px;
`;

const FileIconTextWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  .update-button {
    width: 170px;
    margin-top: 15px;
    color: black;
    background: white;
    border: 1px solid black;
    &:hover {
      border: 1px solid black;
      opacity: .7;
    }
  }
  .file-icon-text {
    font-weight: 900;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .file-icon-text-uploaded {
    font-weight: 900;
    margin-bottom: 10px;
    font-size: 14px;
    color: #0dcc8a;
  }
  .file-icon-text-types {
    margin-top: 10px;
    font-size: 11px;
    text-align: center;
  }
  .file-icon-text-uploaded-fail {
    font-weight: 900;
    margin-bottom: 10px;
    font-size: 14px;
    color: red;
    margin-top: 20px;
    text-align: center;
  }
  .file-icon-text-uploaded-fail-restart {
    font-weight: 900;
    margin-bottom: 10px;
    font-size: 14px;
    color: red;
    margin-top: 10px;
    cursor: pointer;
    text-decoration: underline;
  }
  .file-icon-text-uploaded-success-again {
    font-weight: 900;
    margin-bottom: 10px;
    font-size: 13px;
    color: red;
    margin-top: 10px;
    cursor: pointer;
  }
  .file-icon-text-uploaded-name {
    text-align: center;
    font-weight: 900;
    margin-bottom: 10px;
    font-size: 14px;
    color: #444444;
    margin-top: 15px;
    overflow: hidden;
    width: 100%;
    padding: 0px 20px;
    text-overflow: ellipsis;
    }
  .file-icon-text-or {
    font-weight: 900;
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 14px;
  }
  .file-icon {
    margin-bottom: 10px;
  }
`;

const DropZoneDiv = styled('div')`
  display: flex;
  border: dotted;
  border-color: grey;
  border-width: 2px;
  width: 90%;
  height: 65%;
  cursor: pointer;
  border-radius: 5px;
  margin-bottom: 20px;
`;

const DropZoneDivUploaded = styled('div')`
  display: flex;
  border: solid;
  border-color: #0dcc8a;
  border-width: 2px;
  width: 90%;
  height: 90%;
  border-radius: 5px;
`;

const DropZoneDivUploadedFail = styled('div')`
  display: flex;
  border: solid;
  border-color: red;
  border-width: 2px;
  width: 90%;
  height: 90%;
  border-radius: 5px;
`;

const FolderTextWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
  margin-top: 20px;

  .folder-icon-text {
    font-size: 16px;
  }
`;

const InnerFolderFormWrapper = styled('div')`
  display: flex;
  width: 80%;
  justify-content: left;
  align-items: center;
  margin-top: 5px;

  .formik-form {
    width: 100%;
  }
`;

const OuterFolderFormWrapper = styled('div')`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: -20px;
  margin-bottom: 20px;
`;

const FormGroup = styled('div')`
  label {
    width: 100%;
  }
  button {
    margin-bottom: 20px;
  }
  .easy-join {
    margin-bottom: 15px;
  }

  .formgroup-text {
    margin-top: 12px;
  }
  .optional-text {
    font-size: 14px;
  }
  .caveat-text {
    font-size: 11px;
    margin-top: 4px;
  }
 .caveat-text-fixed {
    font-size: 11px;
    margin-top: 5px;
    min-height: 35px;
    display: block;
  }

  z-index: 1;
  @media screen and (max-width: 600px) {
    a {
      font-size: 11px;
    }
  }
  .form-control {
    min-height: 30px;
    width: 100%;
  }
`;

const ModalCreateForm = ({
  currentUser,
  modalType,
  createDocument,
  onRequestClose,
  setActiveModal,
  currentFolder,
  setCreatedDocumentType,
}) => {
  const {
    handleUploadDocument,
    handleFetchUserGroups,
    handleFetchFolders,
  } = useDocuments();

  const visibleFolders = useSelector((state) => state.documents.data.folders);
  const userGroups = useSelector((state) => state.documents.data.userGroups);
  const userList = useSelector((state) => state.documents.data.userList);
  const uploadedDocument = useSelector((state) => state.documents.data.uploadDocument);
  const uploadDocumentError = useSelector((state) => state.documents.data.uploadDocumentError);
  const createDocumentError = useSelector((state) => state.documents.data.createDocumentError);
  const isDocumentUploading = useSelector((state) => state.documents.ui.isDocumentUploading);
  const isDocumentCreating = useSelector((state) => state.documents.ui.isDocumentCreating);

  const [selectedFolder, setSelectedFolder] = useState({});
  const [isDocumentUploaded, setIsDocumentUploaded] = useState(false);
  const [uploadedDocumentName, setUploadedDocumentName] = useState('');
  const [fadingUsers, setFadingUsers] = useState([]);
  const [hasShownAutoRemovalToast, setHasShownAutoRemovalToast] = useState(false);

  // Fetches list of potential folders
  useEffect(() => {
    const accountCode = currentUser !== undefined && currentUser.accountCode;
    if (accountCode !== undefined && !userGroups) {
      handleFetchUserGroups(accountCode);
    }
    if (!currentFolder && !visibleFolders.length) {
      handleFetchFolders(accountCode);
    }
  }, []);

  const getIndividualAccessMessage = (values) => {
    const hasGroups = Array.isArray(values.groups) && values.groups.length > 0;
    const hasUsers = Array.isArray(values.users) && values.users.length > 0;

    if (hasGroups || hasUsers) {
      return null;
    }

    return '*Leave empty to give access to all available users';
  };

  const displayGroups = groupsRefiner({ userGroups, currentFolder, selectedFolder });
  const displayUsers = usersRefiner({
    userList,
    currentFolder,
    selectedFolder,
    currentUser,
  });

  const handleSubmit = (values, flip) => {
    const newValues = { ...values };

    const hasSelectedGroups = Array.isArray(values.groups) && values.groups.length > 0;
    const hasSelectedUsers = Array.isArray(values.users) && values.users.length > 0;

    // Only inherit from the folder/global context when both dropdowns are left blank
    if (!hasSelectedGroups && !hasSelectedUsers) {
      const accessSource = currentFolder || selectedFolder;

      if (accessSource?.userGroupAccess) {
        newValues.groups = accessSource.userGroupAccess.map((group) => group.id);
      }

      if (accessSource?.individualAccess) {
        newValues.users = accessSource.individualAccess
          .filter((user) => user.first !== null && user.last !== null)
          .map((user) => user.id);
      }
    }

    // Sets the type based on the doc type being created
    if (flip === 'link') {
      if (currentFolder) {
        newValues.folderId = currentFolder.id;
      }
      newValues.type = 2;
      createDocument(currentUser.accountCode, newValues);
    }

    if (flip === 'folder') {
      newValues.type = 0;
      createDocument(currentUser.accountCode, newValues);
    }

    if (flip === 'file') {
      if (currentFolder) {
        newValues.folderId = currentFolder.id;
      }
      newValues.type = 1;
      if (uploadedDocument?.filePath) {
        newValues.filePath = uploadedDocument.filePath;
      }
      createDocument(currentUser.accountCode, newValues);
    }

    setCreatedDocumentType(flip.charAt(0).toUpperCase() + flip.slice(1));
  };

  const handleDroppedFile = (acceptedFile) => {
    handleUploadDocument(currentUser.accountCode, acceptedFile);
    setUploadedDocumentName(acceptedFile);
    setIsDocumentUploaded(true);
  };

  const fileAccepterSwitch = () => {
    if (!isDocumentUploaded) {
      return (
        <Dropzone onDrop={(acceptedFile) => handleDroppedFile(acceptedFile)}>
          {({ getRootProps, getInputProps }) => (
            <DropZoneDiv {...getRootProps()}>
              <input {...getInputProps()} />
              <FileIconTextWrapper>
                <Text className='file-icon-text'>DRAG &amp; DROP FILE</Text>
                <IcomoonReact
                  className='file-icon'
                  iconSet={iconSet}
                  size={65}
                  icon='file'
                />
                <Text className='file-icon-text-or'>OR</Text>
                <Text className='file-icon-text'>CLICK TO UPLOAD</Text>
                <TextTypeWrapper>
                  <Text className='file-icon-text-types'>
                    Accepted file types:
                    {' '}
                    <br />
                    .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx
                  </Text>
                </TextTypeWrapper>
              </FileIconTextWrapper>
            </DropZoneDiv>
          )}
        </Dropzone>
      );
    }
    if (isDocumentUploading) {
      return <Spinner />;
    }
    if (isDocumentUploaded) {
      if (!uploadDocumentError) {
        return (
          <DropZoneDivUploaded>
            <FileIconTextWrapper>
              <Text className='file-icon-text-uploaded'>UPLOADED</Text>
              <Checkmark />
              <Text className='file-icon-text-uploaded-name'>{uploadedDocumentName[0].name}</Text>
              <Button
                className='update-button'
                cta='CHANGE FILE'
                noHover
                noBorder
                primary
                type='button'
                onClick={() => setIsDocumentUploaded(false)}
              />
            </FileIconTextWrapper>
          </DropZoneDivUploaded>
        );
      }
      if (uploadDocumentError) {
        return (
          <DropZoneDivUploadedFail>
            <FileIconTextWrapper>
              <IcomoonReact
                className='file-icon'
                iconSet={iconSet}
                size={75}
                icon='remove'
                color='red'
              />
              <Text className='file-icon-text-uploaded-fail'>Oops! Something went wrong</Text>
              {uploadDocumentError && (
                <Text className='file-icon-text-uploaded-fail'>{uploadDocumentError}</Text>
              )}
              <Text
                onClick={() => setIsDocumentUploaded(false)}
                className='file-icon-text-uploaded-fail-restart'
              >
                Try Again
              </Text>
            </FileIconTextWrapper>
          </DropZoneDivUploadedFail>
        );
      }
    }
    return null;
  };

  const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F1E0}-\u{1F1FF}]/gu;

  const urlSchema = Yup.object().shape({
    linkUrl: Yup.string()
      .url('Invalid URL')
      .required('URL is required'),
    name: Yup.string()
      .required('Name is required')
      .test('no-emojis', 'Emojis are not allowed', (value) => !value || !emojiRegex.test(value)),
    description: Yup.string()
      .test('no-emojis', 'Emojis are not allowed', (value) => !value || !emojiRegex.test(value)),
  });

  const folderSchema = Yup.object().shape({
    name: Yup.string()
      .required('Name is required')
      .test('no-emojis', 'Emojis are not allowed', (value) => !value || !emojiRegex.test(value)),
    description: Yup.string()
      .test('no-emojis', 'Emojis are not allowed', (value) => !value || !emojiRegex.test(value)),
  });

  const fileSchema = Yup.object().shape({
    name: Yup.string()
      .required('Name is required')
      .test('no-emojis', 'Emojis are not allowed', (value) => !value || !emojiRegex.test(value)),
    description: Yup.string()
      .test('no-emojis', 'Emojis are not allowed', (value) => !value || !emojiRegex.test(value)),
  });

  if (modalType === 'add_link_modal') {
    return (
      <Formik
        initialValues={{
          linkUrl: '',
          name: '',
          description: '',
        }}
        validationSchema={urlSchema}
        validateOnChange
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            handleSubmit(values, 'link');
            setSubmitting(false);
          });
        }}
        render={({
          setFieldValue,
          submitForm,
          values,
          errors,
          touched,
        }) => {
          const displayFolders = foldersRefiner({
            visibleFolders,
            userList,
            selectedGroupIds: values.groups || [],
            selectedUserIds: values.users || [],
          });
          return (
            <ModalWrapper>
              <AnotherWrapper>
                <NavigationWrapper>
                  <Text
                    className='back-arrow-div'
                    onClick={() => {
                      setActiveModal('backwards_create_doc_modal');
                    }}
                  >
                    <IcomoonReact
                      iconSet={iconSet}
                      size={15}
                      icon='left-arrow'
                    />
                  </Text>
                  <Text
                    className='back-arrow-div'
                    onClick={() => {
                      onRequestClose();
                    }}
                  >
                    <IcomoonReact
                      iconSet={iconSet}
                      size={10}
                      icon='remove'
                    />
                  </Text>
                </NavigationWrapper>
                <FormWrapper>
                  <LeftWrapper>
                    <GlobeWrapper>
                      <IcomoonReact
                        iconSet={iconSet}
                        size={75}
                        icon='globe'
                      />
                      <SubText className='globe-text'>ADD A LINK</SubText>
                      {createDocumentError ? <TitleError className='error-text'>{createDocumentError}</TitleError> : null}
                    </GlobeWrapper>
                    <URLWrapper>
                      <FormGroup>
                        <TitlePlusErrorWrapper>
                          <Text className='formgroup-text'><strong>URL</strong></Text>
                          {errors.linkUrl && touched.linkUrl ? (
                            <FieldError className='error-text'>{errors.linkUrl}</FieldError>
                          ) : null}
                        </TitlePlusErrorWrapper>
                        <Field
                          className='form-control'
                          id='url-field'
                          name='linkUrl'
                          placeholder='https://domain.com'
                        />
                      </FormGroup>
                      <FormGroup>
                        <Text className='formgroup-text'>
                          <strong>Individual Access</strong>
                          {' '}
                          <span className='optional-text'>(Optional)</span>
                        </Text>
                        <Select
                          key={(values.groups || []).join('-') || 'no-groups'}
                          getOptionLabel={(option) => `${option.first} ${option.last}`}
                          getOptionValue={(option) => option.id}
                          options={displayUsers}
                          value={getVisibleUsers(displayUsers, values.users || [], fadingUsers)}
                          selectedGroups={values.groups || []}
                          userGroups={userGroups}
                          onChange={(options) => handleUserChange(options, setFieldValue, true)}
                          components={{
                            Option: CustomOption,
                            MultiValue: CustomMultiValue,
                          }}
                          fadingUsers={fadingUsers}
                          isUserInSelectedGroups={isUserInSelectedGroups}
                          styles={customSelectStyles}
                          isOptionDisabled={
                          (option) => isUserInSelectedGroups(option, values.groups || [])
                        }
                          isMulti
                        />
                        <Text className='caveat-text-fixed'>
                          {' '}
                          {getIndividualAccessMessage(values)}
                        </Text>
                      </FormGroup>
                    </URLWrapper>
                  </LeftWrapper>
                  <RightWrapper>
                    <Form className='formik-form'>
                      <FormGroup>
                        <TitlePlusErrorWrapper>
                          <Text className='formgroup-text'><strong>Name</strong></Text>
                          {errors.name && touched.name ? (
                            <FieldError className='error-text'>{errors.name}</FieldError>
                          ) : null}
                        </TitlePlusErrorWrapper>
                        <Field
                          className='form-control'
                          id='name-field'
                          name='name'
                          placeholder='Title for link'
                        />
                      </FormGroup>
                      <FormGroup>
                        <TitlePlusErrorWrapper>
                          <Text className='formgroup-text'>
                            <strong>Description</strong>
                            {' '}
                            <span className='optional-text'>(Optional)</span>
                          </Text>
                          {errors.description && touched.description ? (
                            <FieldError className='error-text'>{errors.description}</FieldError>
                          ) : null}
                        </TitlePlusErrorWrapper>
                        <Field
                          className='form-control'
                          id='description-field'
                          name='description'
                          placeholder='Link description'
                        />
                      </FormGroup>
                      <FormGroup>
                        <Text className='formgroup-text'>
                          <strong>Folder</strong>
                          {' '}
                          <span className='optional-text'>(Optional)</span>
                        </Text>
                        <Select
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          options={displayFolders}
                          onChange={(folder) => {
                            setSelectedFolder(folder);
                            if (folder && folder.id) {
                              setFieldValue('folderId', folder.id);
                            } else {
                              setFieldValue('folderId', 0);
                            }
                          }}
                          defaultValue={currentFolder}
                          isDisabled={currentFolder}
                          isClearable
                        />
                      </FormGroup>
                      <FormGroup>
                        <Text className='formgroup-text'>
                          <strong>Group Access</strong>
                          {' '}
                          <span className='optional-text'>(Optional)</span>
                        </Text>
                        <Select
                          defaultValue={values.groups}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          options={displayGroups}
                          onChange={(options) => handleGroupChange({
                            options,
                            values,
                            setFieldValue,
                            userList,
                            isUserInSelectedGroups,
                            setFadingUsers,
                            hasShownAutoRemovalToast,
                            setHasShownAutoRemovalToast,
                            showInfoToast,
                            selectedGroupIds: values.groups,
                            setSelectedGroups: null,
                            storeGroupsAsObjects: false,
                          })}
                          styles={customSelectStyles}
                          isMulti
                        />
                        <Text className='caveat-text-fixed'>
                          {' '}
                          {(!values.groups || values.groups.length === 0)
                          && (!values.users || values.users.length === 0)
                            ? '*Leave empty to give access to all available groups'
                            : null}
                        </Text>
                      </FormGroup>
                    </Form>
                  </RightWrapper>
                </FormWrapper>
              </AnotherWrapper>
              <NoHoverButton
                bottom
                fullWidth
                customColor='#10cd8c'
                cta={!isDocumentCreating ? 'Create Link' : 'Creating...'}
                className='modal-button'
                large
                noBorder
                primary
                square
                disabled={isDocumentCreating || !values.linkUrl || !values.name}
                onClick={() => {
                  submitForm();
                }}
              />
            </ModalWrapper>
          );
        }}
      />
    );
  }
  if (modalType === 'create_folder_modal') {
    return (
      <Formik
        initialValues={{
          name: '',
          description: '',
        }}
        validationSchema={folderSchema}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            handleSubmit(values, 'folder');
            setSubmitting(false);
          });
        }}
        render={({
          values,
          setFieldValue,
          submitForm,
          errors,
          touched,
        }) => (
          <ModalWrapper>
            <AnotherWrapper>
              <NavigationWrapperFolder>
                <Text
                  className='back-arrow-div'
                  onClick={() => {
                    setActiveModal('backwards_create_doc_modal');
                  }}
                >
                  <IcomoonReact
                    iconSet={iconSet}
                    size={15}
                    icon='left-arrow'
                  />
                </Text>
                <Text
                  className='back-arrow-div'
                  onClick={() => {
                    onRequestClose();
                  }}
                >
                  <IcomoonReact
                    iconSet={iconSet}
                    size={10}
                    icon='remove'
                  />
                </Text>
              </NavigationWrapperFolder>
              <OuterFolderFormWrapper>
                <FolderTextWrapper>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={75}
                    icon='folder'
                  />
                  <SubText className='folder-icon-text'>CREATE A FOLDER</SubText>
                  {createDocumentError ? <TitleError className='error-text'>{createDocumentError}</TitleError> : null}
                </FolderTextWrapper>
                <InnerFolderFormWrapper>
                  <Form className='formik-form'>
                    <FormGroup>
                      <TitlePlusErrorWrapper>
                        <Text className='formgroup-text'><strong>Name</strong></Text>
                        {errors.name && touched.name ? (
                          <FieldError className='error-text'>{errors.name}</FieldError>
                        ) : null}
                      </TitlePlusErrorWrapper>
                      <Field
                        className='form-control'
                        id='name-field'
                        name='name'
                        placeholder='Folder Name'
                      />
                    </FormGroup>
                    <FormGroup>
                      <TitlePlusErrorWrapper>
                        <Text className='formgroup-text'>
                          <strong>Description</strong>
                          {' '}
                          <span className='optional-text'>(Optional)</span>
                        </Text>
                        {errors.description && touched.description ? (
                          <FieldError className='error-text'>{errors.description}</FieldError>
                        ) : null}
                      </TitlePlusErrorWrapper>
                      <Field
                        className='form-control'
                        id='description-field'
                        name='description'
                        placeholder='Folder Description'
                      />
                    </FormGroup>
                    <FormGroup>
                      <Text className='formgroup-text'>
                        <strong>Group Access</strong>
                        {' '}
                        <span className='optional-text'>(Optional)</span>
                      </Text>
                      <Select
                        defaultValue={values.groups}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        options={displayGroups}
                        onChange={(options) => handleGroupChange({
                          options,
                          values,
                          setFieldValue,
                          userList,
                          isUserInSelectedGroups,
                          setFadingUsers,
                          hasShownAutoRemovalToast,
                          setHasShownAutoRemovalToast,
                          showInfoToast,
                          selectedGroupIds: values.groups,
                          setSelectedGroups: null,
                          storeGroupsAsObjects: false,
                        })}
                        styles={customSelectStyles}
                        isMulti
                      />
                      <Text className='caveat-text'>
                        {' '}
                        {(!values.groups || values.groups.length === 0)
                          && (!values.users || values.users.length === 0)
                          ? '*Leave empty to give access to all available groups'
                          : null}
                      </Text>
                    </FormGroup>
                    <FormGroup>
                      <Text className='formgroup-text'>
                        <strong>Individual Access</strong>
                        {' '}
                        <span className='optional-text'>(Optional)</span>
                      </Text>
                      <Select
                        key={(values.groups || []).join('-') || 'no-groups'}
                        getOptionLabel={(option) => `${option.first} ${option.last}`}
                        getOptionValue={(option) => option.id}
                        options={displayUsers}
                        value={getVisibleUsers(displayUsers, values.users || [], fadingUsers)}
                        selectedGroups={values.groups || []}
                        userGroups={userGroups}
                        onChange={(options) => handleUserChange(options, setFieldValue, true)}
                        components={{
                          Option: CustomOption,
                          MultiValue: CustomMultiValue,
                        }}
                        fadingUsers={fadingUsers}
                        isUserInSelectedGroups={isUserInSelectedGroups}
                        styles={customSelectStyles}
                        isOptionDisabled={
                          (option) => isUserInSelectedGroups(option, values.groups || [])
                        }
                        isMulti
                      />
                      <Text className='caveat-text'>
                        {' '}
                        {getIndividualAccessMessage(values)}
                      </Text>
                    </FormGroup>
                    {createDocumentError ? <TitleError className='error-text'>{createDocumentError}</TitleError> : null}
                  </Form>
                </InnerFolderFormWrapper>
              </OuterFolderFormWrapper>
            </AnotherWrapper>
            <NoHoverButton
              bottom
              fullWidth
              cta={!isDocumentCreating ? 'Create Folder' : 'Creating...'}
              customColor='#10cd8c'
              className='modal-button'
              large
              noBorder
              primary
              square
              disabled={isDocumentCreating || !values.name}
              onClick={() => {
                submitForm();
              }}
            />
          </ModalWrapper>
        )}
      />
    );
  }
  if (modalType === 'upload_file_modal') {
    return (
      <Formik
        initialValues={{
          name: '',
          description: '',
        }}
        validationSchema={fileSchema}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            handleSubmit(values, 'file');
            setSubmitting(false);
          });
        }}
        render={({
          values,
          setFieldValue,
          submitForm,
          errors,
          touched,
        }) => {
          const displayFolders = foldersRefiner({
            visibleFolders,
            userList,
            selectedGroupIds: values.groups || [],
            selectedUserIds: values.users || [],
          });
          const isSubmitDisabled = isDocumentUploading
            || !isDocumentUploaded
            || uploadDocumentError
            || Object.keys(errors).length > 0
            || !values.name
            || isDocumentCreating;
          return (
            <ModalWrapper>
              <AnotherWrapper>
                <NavigationWrapperFile>
                  <Text
                    className='back-arrow-div'
                    onClick={() => {
                      setActiveModal('backwards_create_doc_modal');
                    }}
                  >
                    <IcomoonReact
                      iconSet={iconSet}
                      size={15}
                      icon='left-arrow'
                    />
                  </Text>
                  <Text
                    className='back-arrow-div'
                    onClick={() => {
                      onRequestClose();
                    }}
                  >
                    <IcomoonReact
                      iconSet={iconSet}
                      size={10}
                      icon='remove'
                    />
                  </Text>
                </NavigationWrapperFile>
                <FileFormWrapper>
                  <LeftWrapper>
                    {fileAccepterSwitch()}
                  </LeftWrapper>
                  <RightWrapper>
                    <Form className='formik-form'>
                      <FormGroup>
                        <TitlePlusErrorWrapper>
                          <Text className='formgroup-text'><strong>Name</strong></Text>
                          {errors.name && touched.name ? (
                            <FieldError className='error-text'>{errors.name}</FieldError>
                          ) : null}
                        </TitlePlusErrorWrapper>
                        <Field
                          className='form-control'
                          id='name-field'
                          name='name'
                          placeholder='Document Name'
                        />
                      </FormGroup>
                      <FormGroup>
                        <TitlePlusErrorWrapper>
                          <Text className='formgroup-text'>
                            <strong>Description</strong>
                            {' '}
                            <span className='optional-text'>(Optional)</span>
                          </Text>
                          {errors.description && touched.description ? (
                            <FieldError className='error-text'>{errors.description}</FieldError>
                          ) : null}
                        </TitlePlusErrorWrapper>
                        <Field
                          className='form-control'
                          id='description-field'
                          name='description'
                          placeholder='Document Description'
                        />
                      </FormGroup>
                      <FormGroup>
                        <Text className='formgroup-text'>
                          <strong>Folder</strong>
                          {' '}
                          <span className='optional-text'>(Optional)</span>
                        </Text>
                        <Select
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          options={displayFolders}
                          onChange={(folder) => {
                            setSelectedFolder(folder);
                            if (folder && folder.id) {
                              setFieldValue('folderId', folder.id);
                            } else {
                              setFieldValue('folderId', 0);
                            }
                          }}
                          defaultValue={currentFolder}
                          isDisabled={currentFolder}
                          isClearable
                        />
                      </FormGroup>
                      <FormGroup>
                        <Text className='formgroup-text'>
                          <strong>Group Access</strong>
                          {' '}
                          <span className='optional-text'>(Optional)</span>
                        </Text>
                        <Select
                          defaultValue={values.groups}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          options={displayGroups}
                          onChange={(options) => handleGroupChange({
                            options,
                            values,
                            setFieldValue,
                            userList,
                            isUserInSelectedGroups,
                            setFadingUsers,
                            hasShownAutoRemovalToast,
                            setHasShownAutoRemovalToast,
                            showInfoToast,
                            selectedGroupIds: values.groups,
                            setSelectedGroups: null,
                            storeGroupsAsObjects: false,
                          })}
                          styles={customSelectStyles}
                          isMulti
                        />
                        <Text className='caveat-text'>
                          {' '}
                          {(!values.groups || values.groups.length === 0)
                          && (!values.users || values.users.length === 0)
                            ? '*Leave empty to give access to all available groups'
                            : null}
                        </Text>
                      </FormGroup>
                      <FormGroup>
                        <Text className='formgroup-text'>
                          <strong>Individual Access</strong>
                          {' '}
                          <span className='optional-text'>(Optional)</span>
                        </Text>
                        <Select
                          key={(values.groups || []).join('-') || 'no-groups'}
                          getOptionLabel={(option) => `${option.first} ${option.last}`}
                          getOptionValue={(option) => option.id}
                          options={displayUsers}
                          value={getVisibleUsers(displayUsers, values.users || [], fadingUsers)}
                          selectedGroups={values.groups || []}
                          userGroups={userGroups}
                          onChange={(options) => handleUserChange(options, setFieldValue, true)}
                          components={{
                            Option: CustomOption,
                            MultiValue: CustomMultiValue,
                          }}
                          fadingUsers={fadingUsers}
                          isUserInSelectedGroups={isUserInSelectedGroups}
                          styles={customSelectStyles}
                          isOptionDisabled={
                          (option) => isUserInSelectedGroups(option, values.groups || [])
                        }
                          isMulti
                        />
                        <Text className='caveat-text'>
                          {' '}
                          {getIndividualAccessMessage(values)}
                        </Text>
                      </FormGroup>
                    </Form>
                  </RightWrapper>
                </FileFormWrapper>
              </AnotherWrapper>
              <NoHoverButton
                bottom
                fullWidth
                cta={!isDocumentCreating ? 'Create File' : 'Creating...'}
                customColor='#10cd8c'
                className='modal-button'
                large
                noBorder
                primary
                square
                onClick={() => {
                  submitForm();
                }}
                disabled={isSubmitDisabled}
                noHover
              />
            </ModalWrapper>
          );
        }}
      />
    );
  }
  return null;
};

ModalCreateForm.propTypes = {
  currentUser: PropTypes.instanceOf(Object).isRequired,
  modalType: PropTypes.string.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  setActiveModal: PropTypes.func.isRequired,
  setCreatedDocumentType: PropTypes.func.isRequired,
  createDocument: PropTypes.func.isRequired,
  currentFolder: PropTypes.instanceOf(Object),
};

ModalCreateForm.defaultProps = {
  currentFolder: false,
};

export default ModalCreateForm;
